//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SiteWeatherDrawer from "./modules/SiteWeatherDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'SiteWeatherList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    SiteWeatherDrawer: SiteWeatherDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/site/weather',
      pageTitle: '站点天气',
      // 表头
      isorter: {
        column: 'time',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'time',
        colName: 'time',
        title: '时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'weather',
        colName: 'weather',
        title: '天气情况',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'temperature',
        colName: 'temperature',
        title: '温度(℃)',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'humidity',
        colName: 'humidity',
        title: '湿度(%)',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'windForce',
        colName: 'wind_force',
        title: '风力(m/s)',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'windDirection',
        colName: 'wind_direction',
        title: '风向',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    onDateTime: function onDateTime(value, dateArray) {
      this.queryParam.timeStart = dateArray[0];
      this.queryParam.timeEnd = dateArray[1];
    },
    handleAdd: function handleAdd() {
      var siteId = this.queryParam.siteId;
      this.$refs.modalForm.add(siteId);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    }
  }
};